export default __webpack_public_path__ + "static/media/support-notes-main-forbes.79ff3b50.png";